const accountReviewPathWithTrackingParameters =
  "/reviews/new/product/keelearning?source=vendorself-amazon-30-keelearning-45e7863ee4a3-keelearning-45922&incentive=amazon-30-keelearning-45e7863ee4a3&utm_campaign=vendorself-amazon-30-keelearning-45e7863ee4a3-keelearning-45922&utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz-8PWrM_YGDkvK-ljmrmxEUcUNDnSs3eOQZOCXGpB6AJ4KEZUqidiuozUZtEOulrwlRe2Al8"

export const ACCOUNT_REVIEW_URL_BY_LANGUAGE = {
  de: `https://omr.com/de${accountReviewPathWithTrackingParameters}`,
  en: `https://omr.com/en${accountReviewPathWithTrackingParameters}`,
  fr: `https://omr.com/en${accountReviewPathWithTrackingParameters}`,
  es: `https://omr.com/en${accountReviewPathWithTrackingParameters}`,
} as const
